import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addActivitystatus,
  getActivitystatuss,
  getActivitystatus,
  editActivitystatus,
  deleteActivitystatus,
  getAllActivitystatuss,
} from "../../store/actions/activitystatus_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllActivitystatuss = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.activitystatus);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteActivitystatus(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getActivitystatuss({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleActivitystatus = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.activitystatus);
  useEffect(() => {
    dispatch(getActivitystatus(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateActivitystatus = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.activitystatus);
  const addData = async (data) => {
    await dispatch(addActivitystatus(data));
  };
  return [data, addData];
};
export const useUpdateActivitystatus = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.activitystatus);
  const updateData = async (id, data) => {
    await dispatch(editActivitystatus(id, data));
  };
  return [updateData];
};

export const useSelectAllActivitystatus = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.activitystatus);
  useEffect(() => {
    dispatch(getAllActivitystatuss({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
